import htmx from "htmx.org";

let name: string | null = null;
let value: string | null = null;

function getCsrfHeaderNameFromMeta(): string {
  const meta = document.querySelector(
    'head meta[name="anti-csrf-header-name"]'
  ) as HTMLMetaElement | null;
  if (meta === null) throw new Error("Could not find name of anti csrf header");
  return meta.content;
}

function getCsrfHeaderValueFromMeta(): string {
  const meta = document.querySelector(
    'head meta[name="anti-csrf-header-value"]'
  ) as HTMLMetaElement | null;
  if (meta === null)
    throw new Error("Could not find value of anti csrf header");
  return meta.content;
}

export function getCsrfHeaderName(): string {
  if (name == null) {
    name = getCsrfHeaderNameFromMeta();
  }
  return name;
}

export function getCsrfHeaderValue(): string {
  if (value == null) {
    value = getCsrfHeaderValueFromMeta();
  }
  return value;
}

htmx.defineExtension("anti-csrf", {
  onEvent: function (name: string, evt: CustomEvent<any>) {
    if (name === "htmx:configRequest" && evt.detail.verb !== "get") {
      evt.detail.headers[getCsrfHeaderName()] = getCsrfHeaderValue();
    }
    return true;
  },
});
